import {CONSONANT_VOWEL_PAIRS_R_L} from "../../../SubjectData/Phonetics/ConsonantVowelPairs/ConsonantVowelPairs_rl.js";
import "../../Deck.css";
import FlashcardInterface from "../../Flashcard_Interface.js";
import HeaderNav from "../../../Components/Header/Header_Nav/Header_Nav.js";



export default function CONSONANT_VOWEL_PAIRS_R_L_DECK() {


 return(
 
     <>
        <HeaderNav GoBack_to={"/ConsonantVowelPairsNav"}/>
        <FlashcardInterface deckData={CONSONANT_VOWEL_PAIRS_R_L} title="Consonant-Vowel Pairs: ㄹ (r/l)" />
     </>
);}